<script lang="ts">
  import { onDestroy, onMount, createEventDispatcher } from "svelte";
  import { focus } from "$actions/focus";
  import { DEFAULT_DEBOUNCE_MS } from "$utils/consts";

  const dispatch = createEventDispatcher<{
    update: { element: HTMLTextAreaElement; value: string };
  }>();

  export let placeholder: string;
  export let value: string = "";
  export let editable = true;
  export let textAlign: "text-left" | "text-center" | "text-right" = "text-center";
  export let focusOnMount = false;
  export let debounceMs: number = DEFAULT_DEBOUNCE_MS;

  let element: HTMLTextAreaElement;
  let timer: NodeJS.Timeout | undefined;

  onDestroy(() => clearTimeout(timer));

  const debounce = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch("update", { element, value });
    }, debounceMs);
  };

  const resize = () => {
    element.style.height = "auto";

    if (element.scrollHeight > element.clientHeight) {
      element.style.height = element.scrollHeight + "px";
    }
  };

  onMount(() => {
    resize();
  });
</script>

<textarea
  readonly={!editable}
  class="{textAlign} w-full resize-none overflow-y-hidden rounded border-0 bg-transparent p-3 text-sm leading-6 font-medium text-neutral-500 caret-neutral-600 transition-colors duration-1000 placeholder:text-neutral-400/60 focus:ring-0 md:text-[13px] dark:text-neutral-400 dark:caret-white dark:placeholder:text-neutral-500"
  class:focus:border-transparent={!editable}
  {placeholder}
  on:input={debounce}
  on:input={resize}
  bind:value
  bind:this={element}
  use:focus={focusOnMount}
/>
